import { mapState } from 'vuex'
import { urlWithParams } from '../helpers/url-params'

export const sharedEventListItemMixin = {
  props: {
    event: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState(['additionalParamsIncludedInEventUrls']),

    actionUrl() {
      if (this.event.publicPath) {
        // Regular event
        const baseUrl = `${window.location.origin}${this.event.publicPath}`
        return urlWithParams(baseUrl, this.additionalParamsIncludedInEventUrls)
      }
      else if (this.event.url) {
        // External event
        return this.event.url
      } else {
        throw `Event with neither path or url: ${this.event}`
      }
    }
  }
}
